import styled from '@emotion/styled';
import { bodyM, subTitle2, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
  * {
    margin: 0;
  }
  ${DESKTOP} {
    gap: 32px;
  }
`;
export const Title = styled.h2`
  white-space: pre-wrap;
  word-break: keep-all;
  ${subTitle2};
  color: ${vars.neutral[0]};
  ${DESKTOP} {
    ${title2};
    color: ${vars.neutral[0]};
  }
`;
export const Descriptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${DESKTOP} {
    gap: 12px;
  }
`;
export const Description = styled.p`
  white-space: pre-wrap;
  word-break: keep-all;
  ${bodyM};
  color: ${vars.neutral[40]};
  ${DESKTOP} {
    ${bodyM};
    color: ${vars.neutral[40]};
  }
`;
